<template>
  <v-container fluid class="settings-tool-page">
    <section class="tool-hero">
      <div>
        <div class="tool-kicker">
          <span class="tool-kicker__icon"><v-icon small>fal fa-file-export</v-icon></span>
          {{ $t("data_management") }}
        </div>
        <h1>{{ $t("export") }}</h1>
        <p>{{ $t("settings_export_intro") }}</p>
      </div>
      <div class="tool-hero__badge">
        <strong>{{ items.length }}</strong>
        <span>{{ $t("export_sources") }}</span>
      </div>
    </section>

    <section class="tool-section">
      <div class="tool-section__heading">
        <div>
          <h2>{{ $t("export") }}</h2>
          <p>{{ $t("choose_export_type") }}</p>
        </div>
        <span class="tool-section__count">{{ items.length }}</span>
      </div>

      <div class="tool-grid">
        <article
          v-for="(item, index) in items"
          :key="index"
          class="tool-card export-card"
          :style="{ '--tool-accent': getColor(index) }"
        >
          <div class="export-card__header">
            <span class="export-card__index">0{{ index + 1 }}</span>
            <span class="export-card__label">{{ $t("data_management") }}</span>
            <div class="tool-card__icon export-card__icon">
              <v-icon>{{ item.icon }}</v-icon>
            </div>
          </div>
          <div class="tool-card__content">
            <h3>{{ item.title }}</h3>
            <p>{{ $t("export_record_type") }}</p>
            <span class="export-card__format">
              <v-icon x-small>fal fa-file-spreadsheet</v-icon>
              XLSX DOWNLOAD
            </span>
          </div>
          <v-btn
            depressed
            color="primary"
            block
            class="tool-card__primary export-card__action"
            @click="exportAction(item)"
          >
            <v-icon left small>fal fa-file-export</v-icon>
            {{ $t("export") }}
          </v-btn>
        </article>
      </div>
    </section>

    <app-custom-dialog
      v-model="dialog"
      :footer="true"
      title="export"
      @submit="submitForm"
    >
      <div slot="activator">
        <v-col cols="12">
          <div class="pb-2">{{ $t("start_date") }}</div>
          <DatePicker v-model="start_date" label="start_date" :placeholder="false" />
          <div class="pb-2 mt-4">{{ $t("end_date") }}</div>
          <DatePicker v-model="end_date" label="end_date" :placeholder="false" />
        </v-col>
      </div>
    </app-custom-dialog>
  </v-container>
</template>

<script>
import { toast } from "@/controllers/alert";

export default {
  data: () => ({
    start_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    end_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    dialog: false,
    select: { title: "product", status: 1, api: "users-export", icon: "fal fa-shopping-cart" },
  }),
  computed: {
    items() {
      return [
        { title: this.$t("product"), status: false, api: "products_export", icon: "fal fa-shopping-cart" },
        { title: this.$t("customer"), status: false, api: "customers_export", icon: "fal fa-users" },
        { title: this.$t("user"), status: false, api: "users_export", icon: "fal fa-user-cog" },
        { title: this.$t("products_notify"), status: false, api: "products_notify_export", icon: "fal fa-layer-group" },
        { title: this.$t("overdue"), status: false, api: "overdue_export", icon: "fal fa-receipt" },
        { title: this.$t("category"), status: false, api: "categories_export", icon: "fal fa-badge-check" },
        { title: this.$t("unit"), status: false, api: "product_size_export", icon: "fal fa-box" },
        { title: this.$t("expense_category"), status: false, api: "expense_category_export", icon: "fal fa-bookmark" },
        { title: this.$t("expense"), status: false, api: "expense_export", icon: "fal fa-wallet" },
        { title: this.$t("best_sale"), status: false, api: "product_best_sell_export", icon: "fal fa-box-open" },
        { title: this.$t("tickets"), status: false, api: "histories_export", icon: "fal fa-chart-bar" },
        { title: this.$t("user_sale"), status: false, api: "users_sale_export", icon: "fal fa-balance-scale" },
        { title: this.$t("ingredient"), status: false, api: "ingredients_export", icon: "fal fa-dolly" },
        { title: this.$t("stock_alert_report"), status: false, api: "download_stock_alert_report", icon: "fal fa-warehouse" },
      ];
    },
  },
  methods: {
    getColor(index) {
      return ["#5b39c9", "#168b78", "#2774c7", "#c87528", "#475569"][index % 5];
    },
    async submitForm() {},
    async exportAction(item) {
      if (item.status) {
        this.dialog = !this.dialog;
        this.select = item;
        return;
      }
      const data = await this.$http.get(`${item.api}`, { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([data.data]));
      const link = document.createElement("a");
      const date = new Date();
      const fileName = `${item.api}-${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}.xlsx`;
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      await toast(this, "downloaded_file_successfully");
    },
  },
};
</script>

<style scoped>
.settings-tool-page { min-height: 100%; background: #f7f8fc; }
.tool-hero, .tool-section { max-width: 1320px; margin: 0 auto; }
.tool-hero { position: relative; display: flex; align-items: center; justify-content: space-between; gap: 24px; padding: 10px 2px 27px; border-bottom: 1px solid #dedee8; color: #252039; }
.tool-hero::after { display: none; }
.tool-kicker { display: flex; align-items: center; gap: 8px; color: #7865be; font-size: 11px; font-weight: 800; letter-spacing: .16em; text-transform: uppercase; }
.tool-kicker__icon { display: inline-flex; width: 34px; height: 34px; align-items: center; justify-content: center; border: 1px solid #d9d1f7; border-radius: 10px; background: #eeeafd; color: #5b39c9; }
.tool-hero h1 { margin: 12px 0 6px; color: #252039; font-size: clamp(30px, 4vw, 44px); font-weight: 800; letter-spacing: -.04em; }
.tool-hero p { max-width: 570px; margin: 0; color: #858a9b; font-size: 14px; line-height: 1.6; }
.tool-hero__badge { display: flex; min-width: 118px; flex-direction: column; padding: 14px 16px; border: 1px solid #e2deef; border-radius: 14px; background: #fff; }
.tool-hero__badge strong { color: #5b39c9; font-size: 28px; }
.tool-hero__badge span { color: #858a9b; font-size: 11px; }
.tool-section { margin-top: 34px; }
.tool-section__heading { display: flex; align-items: flex-end; justify-content: space-between; margin-bottom: 18px; }
.tool-section__heading h2 { margin: 0; color: #252039; font-size: 21px; font-weight: 800; }
.tool-section__heading p { margin: 5px 0 0; color: #858a9b; font-size: 13px; }
.tool-section__count { min-width: 34px; padding: 7px 11px; border-radius: 8px; background: #edeafb; color: #6451ba; font-size: 12px; font-weight: 800; text-align: center; }
.tool-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 16px; }
.tool-card { position: relative; display: flex; min-height: 254px; flex-direction: column; padding: 23px; overflow: hidden; border: 1px solid #e8eaf2; border-radius: 18px; background: #fff; box-shadow: 0 8px 20px rgba(47, 39, 83, .04); transition: transform .2s ease, box-shadow .2s ease, border-color .2s ease; }
.tool-card:hover { border-color: color-mix(in srgb, var(--tool-accent) 45%, #fff); box-shadow: 0 14px 28px rgba(47, 39, 83, .09); transform: translateY(-3px); }
.tool-card__topline { position: absolute; top: 0; right: 0; left: 0; height: 4px; background: var(--tool-accent); }
.tool-card__icon { display: flex; width: 48px; height: 48px; align-items: center; justify-content: center; border-radius: 14px; background: color-mix(in srgb, var(--tool-accent) 12%, #fff); color: var(--tool-accent); }
.tool-card__content { flex: 1; margin-top: 22px; }
.tool-card h3 { margin: 0; color: #292440; font-size: 19px; font-weight: 800; }
.tool-card p { margin: 6px 0 0; color: #8a8e9c; font-size: 12px; }
.tool-card__primary { margin-top: 24px; border-radius: 9px; }
.export-card { min-height: 286px; padding: 0 24px 20px; background: linear-gradient(160deg, #fff 0%, #fbfaff 100%); }
.export-card__header { position: relative; height: 104px; margin: 0 -24px; padding: 17px 22px; border-bottom: 1px solid color-mix(in srgb, var(--tool-accent) 18%, #fff); background: color-mix(in srgb, var(--tool-accent) 9%, #fff); }
.export-card__index { position: absolute; top: 18px; right: 22px; color: #c8c4d5; font-size: 11px; font-weight: 800; letter-spacing: .1em; }
.export-card__label { display: block; color: color-mix(in srgb, var(--tool-accent) 72%, #475569); font-size: 9px; font-weight: 800; letter-spacing: .14em; text-transform: uppercase; }
.export-card__icon { width: 58px; height: 58px; margin-top: 13px; border: 1px solid color-mix(in srgb, var(--tool-accent) 24%, #fff); border-radius: 17px; background: color-mix(in srgb, var(--tool-accent) 12%, #fff); box-shadow: 0 8px 16px color-mix(in srgb, var(--tool-accent) 14%, transparent); }
.export-card__icon .v-icon { color: var(--tool-accent); font-size: 22px; }
.export-card__content { margin-top: 28px; }
.export-card__content p { max-width: 210px; min-height: 30px; line-height: 1.45; }
.export-card__format { display: inline-flex; align-items: center; gap: 5px; margin-top: 12px; padding: 5px 8px; border: 1px solid #e7e4ef; border-radius: 6px; background: #fff; color: #7b7790; font-size: 10px; font-weight: 800; letter-spacing: .06em; }
.export-card__format .v-icon { color: var(--tool-accent); }
.export-card__action { margin-top: 20px; }

/* Dark Mode Overrides */
.theme--dark.settings-tool-page,
.theme--dark .settings-tool-page {
  background: transparent !important;
}
.theme--dark .tool-hero {
  border-bottom-color: rgba(255, 255, 255, 0.08);
  color: #ffffff;
}
.theme--dark .tool-kicker {
  color: #a5b4fc;
}
.theme--dark .tool-kicker__icon {
  background: rgba(129, 140, 248, 0.15);
  border-color: rgba(129, 140, 248, 0.35);
  color: #c4b5fd;
}
.theme--dark .tool-hero h1 {
  color: #ffffff;
}
.theme--dark .tool-hero p {
  color: #94a3b8;
}
.theme--dark .tool-hero__badge {
  background: #1e1e2d;
  border-color: rgba(255, 255, 255, 0.08);
}
.theme--dark .tool-hero__badge strong {
  color: #a5b4fc;
}
.theme--dark .tool-hero__badge span {
  color: #94a3b8;
}
.theme--dark .tool-section__heading h2 {
  color: #ffffff;
}
.theme--dark .tool-section__heading p {
  color: #94a3b8;
}
.theme--dark .tool-section__count {
  background: rgba(129, 140, 248, 0.18);
  color: #c4b5fd;
}
.theme--dark .tool-card,
.theme--dark .export-card {
  background: #1e1e2d !important;
  border-color: rgba(255, 255, 255, 0.08);
  box-shadow: none;
}
.theme--dark .tool-card:hover {
  border-color: color-mix(in srgb, var(--tool-accent) 60%, #1e1e2d);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.35);
}
.theme--dark .export-card__header {
  background: color-mix(in srgb, var(--tool-accent) 16%, #262638);
  border-bottom-color: rgba(255, 255, 255, 0.06);
}
.theme--dark .export-card__index {
  color: rgba(255, 255, 255, 0.28);
}
.theme--dark .export-card__label {
  color: color-mix(in srgb, var(--tool-accent) 55%, #e2e8f0);
}
.theme--dark .export-card__icon {
  background: color-mix(in srgb, var(--tool-accent) 22%, #1e1e2d);
  border-color: color-mix(in srgb, var(--tool-accent) 38%, #1e1e2d);
}
.theme--dark .tool-card h3 {
  color: #ffffff;
}
.theme--dark .tool-card p {
  color: #94a3b8;
}
.theme--dark .export-card__format {
  background: #262638;
  border-color: rgba(255, 255, 255, 0.08);
  color: #cbd5e1;
}

@media (max-width: 1000px) { .tool-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
@media (max-width: 650px) { .settings-tool-page { padding: 18px 12px 32px !important; } .tool-hero { align-items: stretch; flex-direction: column; padding: 26px 22px; } .tool-hero::after { display: none; } .tool-hero__badge { min-width: 0; } .tool-grid { grid-template-columns: 1fr; } .tool-section__heading { align-items: flex-start; } }
</style>
